/**
 * The GroundTruth bulk editor's starter panel ("What do you want to change?").
 *
 * Shared by the two GroundTruth bulk-editor surfaces, the Campaign Launch
 * Workflow review pane and the launched-campaign details page, so they cannot
 * drift. Every other platform keeps the panel its host builds.
 *
 * GroundTruth account managers found "staged" confusing, and the "Try asking"
 * list of example prompts was noise to them, so this panel says what the agent
 * does in plain words and stops there: no section label, no prompt chips.
 *
 * @param {string} rowLabel  the plural row noun shown in the grid ("ad groups")
 * @returns {{ title, body }} an AgentSidebar `config.placeholder`
 */
export function gtBulkPlaceholder(rowLabel = 'ad groups') {
  return {
    title: 'What do you want to change?',
    body: (
      <>I can change <strong>dates</strong>, <strong>budgets</strong> and <strong>geo</strong> across many {rowLabel} at once, and copy or delete them. I'll show you exactly what changes and ask before anything is updated.</>
    ),
  };
}

export default gtBulkPlaceholder;
